module.exports = "<!-- <h1>INSA Task List</h1> -->\r\n<div class=\"wide-grid\">\r\n  <generic-grid [metadataName]=\"taskListName\"></generic-grid>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-task-list/insa-task-list.component.html
// module id = 1742
// module chunks = 2